import { createContext } from 'react';

export const EPCContext = createContext({});